<template>
  <section>
    <plaid-link
      env="production"
      publicKey="886db1962c11b1d9252fd8be9b593e"
      clientName="Lendwizely"
      :product="['auth', 'transactions']"
      :token="params.token"
      v-bind="{ onSuccess, onLoad }"
      class="test btnOpenPlaid"
      :style="getStyle(isPlaidReady)"
    >
      Open Link and connect your bank!
    </plaid-link>
  </section>
</template>

<script>
import PlaidLink from "vue-plaid-link";
import queryString from 'query-string';
import axios from 'axios'
import {URL} from '../../env'

export default {
  components: { PlaidLink },
  methods: {
    onSuccess(token) {
      axios.post(`${URL}/receive_accounting/public_token`, {
        public_token: token,
        company_plaid_id: queryString.parse(window.location.search).id
      })
    },
    onLoad(){
        this.isPlaidReady = true
        const elm = document.getElementsByClassName("btnOpenPlaid")[0];
        elm.click();
    },
    getStyle(isPlaidReady){
        return isPlaidReady ? {'margin-top': '10px'} : {'margin-top': '10px', 'display': 'none'}
    }
  },
  created(){
    this.params = queryString.parse(window.location.search) 
  },
  data() {
    return {
        isPlaidReady: false,
        params: {}
    }
  }
};
</script>